import Immutable from 'immutable';
import moment from 'moment';

const LOAD = 'cropProductionSalesReport/LOAD';
const LOAD_SUCCESS = 'cropProductionSalesReport/LOAD_SUCCESS';
const LOAD_FAIL = 'cropProductionSalesReport/LOAD_FAIL';

const CROPPRODUCTION_LOAD_FAIL  = 'cropProductionSalesReport/CROPPRODUCTION_LOAD_FAIL';
const CROPPRODUCTION_LOAD_SUCCESS = 'cropProductionSalesReport/CROPPRODUCTION_LOAD_SUCCESS';
const CROPPRODUCTION_LOAD_ADD_SUCCESS = 'cropProductionSalesReport/CROPPRODUCTION_LOAD_ADD_SUCCESS';
const CROPPRODUCTION_LOAD_UPDATE_SUCCESS = 'cropProductionSalesReport/CROPPRODUCTION_LOAD_UPDATE_SUCCESS';

const CROPPRODUCTPRODUCTION_LOAD_FAIL  = 'cropProductionSalesReport/CROPPRODUCTPRODUCTION_LOAD_FAIL';

const CROPPRODUCTIONSALES_LOAD_FAIL  = 'cropProductionSalesReport/CROPPRODUCTIONSALES_LOAD_FAIL';
const CROPPRODUCTIONSALES_LOAD_UPDATE_SUCCESS = 'cropProductionSalesReport/CROPPRODUCTIONSALES_LOAD_UPDATE_SUCCESS';

const UPDATE_TOTAL_PROD_FAIL  = 'cropProductionSalesReport/UPDATE_TOTAL_PROD_FAIL';
const UPDATE_TOTAL_PROD_SUCCESS = 'cropProductionSalesReport/UPDATE_TOTAL_PROD_SUCCESS';

const UPDATE_CROP_PRODUCT_DATA_FAIL  = 'cropProductionSalesReport/UPDATE_CROP_PRODUCT_DATA_FAIL';
const UPDATE_CROP_PRODUCT_DATA_SUCCESS = 'cropProductionSalesReport/UPDATE_CROP_PRODUCT_DATA_SUCCESS';

const initialState = Immutable.fromJS({
  CropProductionSalesReport: null,
  cropProdctionData: {},
  cropProductProductionData:null,
  cropProdctionSalesData:null,
  loading: false,
  errorMessage: null,
  cropTotalProduction: null,
  updatedCropProductProData: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case LOAD:
    return state
    .set('loading', true);

    case LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('CropProductionSalesReport', action.CropProductionSalesReport);

    case CROPPRODUCTION_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case CROPPRODUCTION_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('cropProdctionData', action.cropProdctionData);

    case CROPPRODUCTION_LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('cropProductProdctionData', action.result);

    case CROPPRODUCTION_LOAD_UPDATE_SUCCESS:
    return state
    .set('loading', false)
    .set('cropProdctionData', action.cropProdctionData);

    case CROPPRODUCTPRODUCTION_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case CROPPRODUCTIONSALES_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case CROPPRODUCTIONSALES_LOAD_UPDATE_SUCCESS:
    return state
    .set('loading', false)
    .set('cropProdctionSalesData', action.cropProdctionSalesData);

    case UPDATE_TOTAL_PROD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case UPDATE_TOTAL_PROD_SUCCESS:
    return state
    .set('loading', false)
    .set('cropTotalProduction', action.cropTotalProduction);

    case UPDATE_CROP_PRODUCT_DATA_FAIL: 
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case UPDATE_CROP_PRODUCT_DATA_SUCCESS
    : return state
    .set('loading', false)
    .set('updatedCropProductProData', action.updatedCropProductProData);

    default:
    return state;
  }
}

export const getPrintSalesByElevAndCrop = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.put('/getCropSalesByElevWorksheet/all', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, CropProductionSalesReport: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const generateLeaseExpirationsWorksheetPdf = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.put('/getFarmLeaseExpirationWorksheet', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return  res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const generateCashRentDueWorksheetPdf = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.put('/getFarmLeaseCashRentDueWorksheet/all', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return  res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const generateCropInsuranceReportPdf = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.put('/getFarmCropInsuranceReportByYear/all', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return  res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

const sum = a => a.reduce((x, y) => x + y)
export const getCropProductionByFarmId = (id) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/getCropProduction/'+id);
    if (res.message) {
      dispatch({ type:CROPPRODUCTION_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    
    const list = (res.filter(item => item.for_Year) || []).map(item => {
      const sales = item.farm_crop_production_sales.length > 0 ? item.farm_crop_production_sales : [{
        units_sold: 0,
        paid: false
      }];
      sales.map(sale => {
        sale.paid = (sale.paid === '1' || sale.paid === null) ? true : false;
        sale.sale_date = sale.sale_date 
                  ? moment(sale.sale_date).utc().format('MM/DD/YYYY') 
                  : moment().utc().format('MM/DD/YYYY') ;
        return sale;
      })
      const totalUnitsSold = sum(sales.map(x => Number(x.units_sold)));
      const ownerShare = (item.total_Prod * ((item.crop_percent ? item.crop_percent : 0) / 100)).toFixed(2);
      const balanceToSell = (ownerShare - totalUnitsSold).toFixed(2);
      let forYear = item.for_Year || moment(item.for_Year).format('YYYY') ;
      return Object.assign({}, item, { 
          owner_Share: ownerShare,
          balanceToSell: balanceToSell,
          actualYLD:  item.acres > 0 ? (item.total_Prod / Number(item.acres)).toFixed(2) : 0,
          totalUnitsSold,
          for_Year: Number(forYear),
          farm_crop_production_sales: Object.assign([], sales)
        }
      );
    })
    const sortedRes = list.sort((a, b) => b.for_Year - a.for_Year );

    dispatch({ 
      type: CROPPRODUCTION_LOAD_SUCCESS, 
      cropProdctionData: { data: sortedRes.length > 0 
        ? sortedRes 
        : [{ farm_id: id, farm_crop_production_sales: [{ paid: false, crop_production_id: id }] }] 
      } 
    });
    return sortedRes ;
  } catch (error) {
    dispatch({ type: CROPPRODUCTION_LOAD_FAIL, errorMessage: error });
  }
};

export const addCropProductionSale = (id) => (dispatch, getState) =>  new Promise((resolve, reject) => {
  const cropProdctionData = getState().get('cropProductionSalesReport').get('cropProdctionData');
  const data = cropProdctionData.data;  
  data.splice(0, 0, {
    farm_id: id,
    farm_crop_product_productions: [],
    farm_crop_production_sales: []
  }); 

  dispatch({ 
    type: CROPPRODUCTION_LOAD_SUCCESS, 
    cropProdctionData: { data: Object.assign([], data) }
  });
  resolve(data);
});

export const proSalesLdpSummary = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.post('/getProSalesLdpSummary', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, CropProductionSalesReport: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const generateCrpExpirationsWorksheetPdf = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.put('/getCrpExpirationsWorksheetPdf', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return  res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const addCropProductProduction = (data, cropProd) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  const index = cropProd.findIndex(pd => pd.id === data.crop_production_id);
  const selectedItem = cropProd[index];
  
  data.totalProd = selectedItem ? Number(selectedItem.total_Prod) + Number(data.last_production_entered) : 0;
  try {
    const res = await api.post('/addCropProductProduction/', { data });
    if (res.message) {
      dispatch({ type: CROPPRODUCTPRODUCTION_LOAD_FAIL, errorMessage: res.message });
      return;
    }   

    const newProductions = selectedItem.farm_crop_product_productions || [];
    newProductions.push(res);
    
    selectedItem.farm_crop_product_productions = newProductions;
    selectedItem.total_Prod = data.totalProd;  
    selectedItem.owner_Share = (data.totalProd * ((selectedItem.cropPercent ? selectedItem.cropPercent : 0) / 100)).toFixed(2);

    cropProd[index] = selectedItem;
    dispatch({ 
      type: CROPPRODUCTION_LOAD_SUCCESS, 
      cropProdctionData: { data: cropProd } 
    });
    return data.totalProd;
  } catch (error) {
    dispatch({ type: CROPPRODUCTPRODUCTION_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const deletefarmCropProductProductions = (payload, id, cropData) => async (dispatch, getState, api) => {
  const index = cropData.findIndex(pd => pd.id === id);
  const selectedItem = cropData[index];

  const leftItems = selectedItem.farm_crop_product_productions.filter(prod => prod.id !== payload.id );
  const total_Prod = Number(selectedItem.total_Prod) - Number(payload.last_production_entered);
  const data = {
    id: payload.id,
    totalProd: total_Prod,
    cropProductionId: id
  };

  dispatch({ type: LOAD });
  try {
    const res = await api.del('/deleteCropProductProduction/', { data });
    if (res.message) {
      dispatch({ type: CROPPRODUCTPRODUCTION_LOAD_FAIL, errorMessage: res.message });
      return;
    }

    selectedItem.farm_crop_product_productions = leftItems;
    selectedItem.total_Prod = total_Prod; 
    selectedItem.owner_Share = (total_Prod * ((selectedItem.cropPercent ? selectedItem.cropPercent : 0) / 100)).toFixed(2);

    cropData[index] = selectedItem; 
    dispatch({ 
      type: CROPPRODUCTION_LOAD_SUCCESS, 
      cropProdctionData: { data: cropData } 
    });
    return total_Prod;
  } catch (error) {

    dispatch({ type: CROPPRODUCTPRODUCTION_LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const addCropProduction = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.post('/addCropProduction/', { data });
    if (res.message) {
      dispatch({ type: CROPPRODUCTION_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: CROPPRODUCTION_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: CROPPRODUCTION_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const deletefarmCropProduction = (id, index = 0) => async (dispatch, getState, api) => {
  const data = {id};  
  dispatch({ type: LOAD });
  let leftItems = [];
  const cropProdctionData = getState().get('cropProductionSalesReport').get('cropProdctionData');  
  const list = cropProdctionData.data;
  try {
    let res;
    if (id) { // existing record
      res = await api.del('/deleteCropProduction/', { data });
      if (res.message) {
        dispatch({ type: CROPPRODUCTION_LOAD_FAIL, errorMessage: res.message });
        return;
      }
      leftItems = list.filter(item => item.id !== id);
    } else {
      leftItems = list.filter((item, key) => key !== index);
    }
    
    dispatch({ 
      type: CROPPRODUCTION_LOAD_SUCCESS, 
      cropProdctionData: { data: Object.assign([], leftItems ) }});
    return res;
  } catch (error) {
    dispatch({ type: CROPPRODUCTION_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getCropSoldNoPayment = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/getCropSoldNoPayment/all', { data });

    if (res.message) {
      dispatch({ type:CROPPRODUCTIONSALES_LOAD_FAIL, errorMessage: res.message });
      return;
    }

    dispatch({ type: CROPPRODUCTIONSALES_LOAD_UPDATE_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: CROPPRODUCTIONSALES_LOAD_FAIL, errorMessage: error.message || error });
  }
};

 export const generateLeaseCashRentCrpReportPdf = (data) => async (dispatch, getState, api) => {

   dispatch({ type: LOAD });

   try {
     const res = await api.put('/getLeaseCashRentCrpReportPdf', { data });
     if (res.message) {
       dispatch({ type: LOAD_FAIL, errorMessage: res.message });
       return;
     }
     return  res;
   } catch (error) {
     dispatch({ type: LOAD_FAIL, errorMessage: error });
   }
 };

 export const updateProdAndSales = (data) => async (dispatch, getState, api) => {  
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/updateProdAndSales/', { data });

    if (res.message) {
      dispatch({ type:CROPPRODUCTION_LOAD_FAIL, errorMessage: res.message });
      return;
    }

    dispatch({ type: CROPPRODUCTION_LOAD_UPDATE_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: CROPPRODUCTION_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const updateProdCropAndSales = (data) => async (dispatch, getState, api) => {  
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/update-production-crop-sales/', { data });

    if (res.message) {
      dispatch({ type:CROPPRODUCTION_LOAD_FAIL, errorMessage: res.message });
      return;
    }

    dispatch({ type: CROPPRODUCTION_LOAD_UPDATE_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: CROPPRODUCTION_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const addTotalProduction = (data, cropProd) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  const index = 0;
  const selectedItem = cropProd[index];
  data.totalProd = selectedItem ? Number(selectedItem.total_Prod) + Number(data.last_production_entered) : 0;
  try {   
    if(isNaN(data.totalProd) === true) {
      data.totalProd = data.last_production_entered;
    } else {
      data.totalProd = selectedItem ? Number(selectedItem.total_Prod) + Number(data.last_production_entered) : 0;
    }
    const res = await api.post('/update-total-production', { data });
    if (res.message) {
      dispatch({ type: CROPPRODUCTPRODUCTION_LOAD_FAIL, errorMessage: res.message });
    }   
      let obj = {
        id: res.id,
        date_updated: res.date_updated,
        last_production_entered: res.last_production_entered
      }
      cropProd[0].farm_crop_product_productions.push(obj);
      cropProd[0].total_Prod = data.totalProd;  
      dispatch({ 
        type: CROPPRODUCTION_LOAD_SUCCESS, 
        cropProdctionData: { data: Object.assign([], cropProd) }
      });
      return data.totalProd;
  } catch (error) {
    dispatch({ type: UPDATE_TOTAL_PROD_FAIL, errorMessage: error.message || error });
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/cropProductionSalesReport.js